/**
 * List is sorted by priority
 */
// import "./vendor/partytown/lib/partytown.js";

// Component
import "./template-parts/component/accordion/product-information/js/script.js";
import "./template-parts/component/button/js/script.js";
import "./template-parts/component/cards/products/js/script.js";
import "./template-parts/component/cart-item/js/script.js";
import "./template-parts/component/fire-sale/js/fire-sale.js";
import "./template-parts/component/form/billing-information/js/add-billing-address.js";
import "./template-parts/component/form/quantity/js/script.js";
import "./template-parts/component/form/shipping-information/js/add-shipping-address.js";
import "./template-parts/component/modal/flash-sales/js/flash-sales.js";
import "./template-parts/component/origo/campaigns/banners/js/script.js"
import "./template-parts/component/origo/opening-hours/js/script.js";
import "./template-parts/component/product-options/js/script.js";
import "./template-parts/component/push-notification/form/js/script.js";
import "./template-parts/component/toggle/vat-switch/js/script.js";

// Global
import "./template-parts/global/dom/js/script.js";
import "./template-parts/global/js/cookie.js";
import "./template-parts/global/js/get-post-id.js";
import "./template-parts/global/js/origo-api.js";

// Page
import "./template-parts/page/checkout/js/script.js";

// Section
import "./template-parts/section/fire-sale/js/fire-sale.js";
import "./template-parts/section/header/js/script.js";
import "./template-parts/section/offcanvas/js/script.js";
import "./template-parts/section/offcanvas/menu/js/script.js";
import "./template-parts/section/offcanvas/search/js/script.js";
import "./template-parts/section/slider/hero/js/script.js";
import "./template-parts/section/slider/product-images/js/script.js";
import "./template-parts/section/homepage-categories/js/script.js";
import "./template-parts/section/homepage-reviews/js/script.js";

// Vendor
import "./template-parts/vendor/fancyapps/ui/js/script.js";
import "./template-parts/vendor/google/reviews-badge/js/script.js";
import "./template-parts/vendor/gravity-forms/js/add-address.js";
import "./template-parts/vendor/postcode/js/postcode.js";
// trigger
// trigger
// trigger
